import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, ConfigProvider } from 'antd';
import StepIcons from './icons/StepIcons';
import './styles.css';

const IMAGES = {
    hero: 'https://cms.e-feed.ru/wp-content/uploads/2022/12/DSC00833-1024x576.jpg',
    gallery: [
        'https://cms.e-feed.ru/wp-content/uploads/2022/12/DSC00864-1024x576.jpg',
        'https://cms.e-feed.ru/wp-content/uploads/2022/12/DSC00890-1024x576.jpg',
        'https://cms.e-feed.ru/wp-content/uploads/2022/12/DSC00787-1024x576.jpg',
        'https://cms.e-feed.ru/wp-content/uploads/2022/12/DSC00802-1024x576.jpg',
    ],
};

const steps = [
    'Оформление заявки на отбор проб по телефону, либо на сайте',
    'Выезд специалиста в хозяйство',
    'Отбор и подготовка проб',
    'Определение питательности кормов, и их оценка',
    'Производится химический анализ, оценка перевариваемости кормов и рационов',
    'Результат высылается заказчику в течение 7 рабочих дней',
];

const FeedLab = () => {
    const navigate = useNavigate();

    return (
        <ConfigProvider
            theme={{
                token: { colorPrimary: '#D00202' },
                components: { Button: { colorPrimaryHover: '#ff3333' } },
            }}
        >
            <div className="feedlab-page">
                <div className="feedlab-container">
                    <h1 className="feedlab-title">Кормовая лаборатория LABPRO</h1>

                    <img
                        className="feedlab-hero-img"
                        src={IMAGES.hero}
                        alt="Кормовая лаборатория LABPRO"
                    />

                    <section className="feedlab-section">
                        <p>
                            От качества комбикорма может зависеть продуктивность животноводства. Поэтому независимая
                            кормовая лаборатория LABPRO является надёжным партнёром и неотъемлемой частью всего процесса
                            производства молока.
                        </p>
                        <p>
                            Сотрудники LABPRO имеют возможность определять энергетическую и кормовую ценность продуктов
                            и контролировать их безопасность.
                        </p>
                    </section>

                    <section className="feedlab-section">
                        <h2>ЦЕЛЬ СОЗДАНИЯ ЛАБОРАТОРИИ LABPRO</h2>
                        <p>
                            Для того чтобы сделать рацион сельскохозяйственных животных и птиц более качественным,
                            сбалансированным, необходимо знать точно, насколько полезен и питателен их рацион. Современная
                            кормовая лаборатория LABPRO была основана для получения необходимых аналитических данных в
                            короткие промежутки времени.
                        </p>
                        <p>
                            Целью создания кормовой лаборатории LABPRO является обслуживание самых разных типов
                            сельскохозяйственных предприятий, отраслей, индивидуальных специалистов.
                        </p>
                    </section>

                    <section className="feedlab-section">
                        <h2>ПРИ ПОМОЩИ ПРОФЕССИОНАЛЬНОГО, ГРАМОТНОГО ПОДХОДА МОЖНО ОБЕСПЕЧИТЬ:</h2>
                        <ol>
                            <li>Составление оптимальных рационов для животных и птиц</li>
                            <li>Формирование структуры кормовой базы</li>
                            <li>Увеличение количества лактаций и показателей удоя</li>
                            <li>Повышение эффективности применения комбикорма</li>
                            <li>Контроль состояния корма при его заготовке и хранении</li>
                            <li>Улучшение пищеварения и здоровья крупного рогатого скота</li>
                            <li>Установление сроков уборки урожая при заготовке грубых кормов</li>
                        </ol>
                        <p>
                            При наличии современной кормовой лаборатории можно значительно повысить рентабельность в
                            короткие сроки. Любые исследования проводятся, исходя из условий конкретного региона и
                            особенностей сельскохозяйственного объекта
                        </p>
                    </section>

                    <section className="feedlab-section">
                        <h2>ПРЕИМУЩЕСТВА ЛАБОРАТОРИИ LABPRO</h2>
                        <p>
                            Независимая кормовая лаборатория LABPRO оснащена по последнему слову техники. В ней
                            используется современное оборудование для высокоточного анализа сельскохозяйственной
                            продукции c использованием химического определения показателей кормов. В лаборатории
                            LABPRO можно оперативно определить такие качественные показатели корма как: содержание
                            влаги, сырого протеина, сырого жира, макро и микроэлементов.
                        </p>
                        <p>
                            Данные методы являются максимально эффективными и точными. Кормовая лаборатория LABPRO
                            позволяет получать информацию в максимально короткие сроки.
                        </p>
                        <div className="feedlab-gallery">
                            {IMAGES.gallery.map((src, i) => (
                                <img key={i} src={src} alt={`Лаборатория LABPRO ${i + 1}`} />
                            ))}
                        </div>
                    </section>

                    <section className="feedlab-section">
                        <h2>КАК ПРОИСХОДИТ ОТБОР ПРОБ</h2>
                        <div className="feedlab-steps">
                            {steps.map((text, i) => {
                                const Icon = StepIcons[i];
                                return (
                                    <div className="feedlab-step" key={i}>
                                        <Icon />
                                        <div className="feedlab-step-number">Этап {i + 1}</div>
                                        <p>{text}</p>
                                    </div>
                                );
                            })}
                        </div>
                    </section>

                    <div className="feedlab-order-btn">
                        <Button
                            type="primary"
                            size="large"
                            onClick={() => navigate('/product/277497')}
                        >
                            Заказать услугу
                        </Button>
                    </div>
                </div>
            </div>
        </ConfigProvider>
    );
};

export default FeedLab;
